import { Bar } from 'react-chartjs-2';
import styles from 'styles/components/pages/professor/statistics/SimpleBarChart.module.scss';
import { STYLES_VARIABLES } from 'constants/styleVariables';
import { getScoreLabel, getScoreColor } from 'utils/score';
import { TScore } from 'types/chart';

type TProps = {
  data: TScore[];
};

export const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    datalabels: {
      align: 'top' as const,
      anchor: 'end' as const,
      font: {
        size: 14,
      },
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
      ticks: {
        font: {
          size: 14,
          weight: 'bold',
        },
      },
    },
    y: {
      display: false,
      max: 110, // Y축 최대값 설정
      min: 0, // Y축 최소값 설정
    },
  },
};

const SimpleBarChart = ({ data }: TProps) => {
  const barData = {
    labels: data.map((item) => item.label),
    datasets: [
      {
        label: '',
        data: data.map((item) => item.score),
        backgroundColor: data.map(
          (item) => STYLES_VARIABLES[getScoreColor(item.score)]
        ),
        barThickness: 64,
        borderRadius: 8,
        datalabels: {
          color: data.map(
            (item) => STYLES_VARIABLES[getScoreColor(item.score)]
          ),
        },
      },
    ],
  };

  return (
    <div className={styles.section}>
      <h2 className="main_title">학생 종합 평가 점수</h2>
      <div className={styles.wrapper}>
        {/* 바 그래프 */}
        <div>
          <p className={styles.unit}> 단위 : (점)</p>
          <Bar width={440} height={304} data={barData} options={options} />
        </div>
        {/* 테이블 */}
        <table>
          <thead>
            <tr className={styles.tr}>
              <th className={styles.table_title}>항목</th>
              <th className={styles.table_title}>점수</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr className={styles.tr} key={index}>
                <th className={styles.table_column}>
                  {item.label}
                  {item.label !== '-' && ' 평균'}
                </th>
                <th
                  className={styles.table_column}
                  style={{
                    fontWeight: 'bold',
                    color:
                      STYLES_VARIABLES[
                        getScoreColor(
                          item.score !== null ? item.score : '미제출'
                        )
                      ],
                  }}
                >
                  {getScoreLabel(item.score !== null ? item.score : '-')}
                </th>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SimpleBarChart;
